import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import navigationConfig from './config/navigationConfig';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="site-footer">
      <div className="footer-content">
        {/* 根据导航配置动态生成页脚栏目 */}
        {navigationConfig.map((section) => {
          // 如果是 Connect Us（没有子项），跳过不显示在页脚
          if (!section.subItems || section.subItems.length === 0) {
            return null;
          }
          
          return (
            <div className="footer-section" key={section.id}>
              <h3>{t(section.labelKey)}</h3>
              <ul>
                {section.subItems.map((item) => (
                  <li key={item.id}>
                    {item.isLink ? (
                      <Link to={item.href}>{t(item.labelKey)}</Link>
                    ) : (
                      <a href={item.href}>{t(item.labelKey)}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
      
      <div className="footer-bottom">
        <div className="copyright">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
